export const border = { borderRight: 1, borderColor: "#0000001A" };

export const format = (value: any) => {
    if (value) {
        return (+value).toFixed(2);
    } else return '';
}